import React, {Component} from 'react';
import { Container, Row, Col, Card, CardHeader, CardTitle, CardBody, CardFooter, Table, Button } from 'reactstrap';
import Calendar from 'react-calendar';
import moment from 'moment';

import ProductSearch from '../../components/Product/Search';
import Config from '../../config';

import './Daterangepicker.css';
import './Productlist.css';
import './Calendar.css'

class OrderList extends Component {
 constructor(props) {
  super(props);

  this.state = {
   pid: 0,
   date: new Date(),
   start: moment().format('YYYY-MM-DD'),
   end: moment().format('YYYY-MM-DD'),
   orders: []
  }

  this.onChange = this.onChange.bind(this);
  this.downloadTicket = this.downloadTicket.bind(this);
 }

 onChange(date) {
  this.setState({
   date,
   start: moment(date).format('YYYY-MM-DD'),
   end: moment(date).format('YYYY-MM-DD')
  }, this.getOrders);
 }

 getOrders() {
  this.props.reqAPI(Config.apiURI+'/api/orders/tickets', 'POST', {
   pid: this.state.pid,
   start: this.state.start,
   end: this.state.end
  }).then((orders) => {
   this.setState({orders}, () => {
    window.scrollTo(0, 0);
   });
  }).catch((error) => {
   console.log(error);
  })
 }

 downloadTicket(id) {
  this.props.reqAPI(Config.apiURI+'/api/pdf/ticket?id='+id).then(data => {
   const linkSource = `data:application/pdf;base64,${data.base64}`;
   const downloadLink = document.createElement("a");
   const pad = "0000000000";
   const fileName = "Ticket-"+(pad+id).slice(-pad.length)+".pdf";
   downloadLink.href = linkSource;
   downloadLink.download = fileName;
   downloadLink.click();
  }, err => {
   console.log(err);
  })
 }

 componentWillMount() {
  this.getOrders();
 }

 render() {
  if(this.state.start === this.state.end) {
   var humanDate = new Date(Date.parse(this.state.start)).toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
  } else {
   var humanDate = new Date(Date.parse(this.state.start)).toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
   humanDate += ' - ' + new Date(Date.parse(this.state.end)).toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
  }

  return (
   <section>
    <Card>
     <CardBody>
      <Calendar onChange={this.onChange} maxDate={new Date()} showNavigation={true} value={this.state.date} />
     </CardBody>
     <CardFooter>
      <ProductSearch reqAPI={this.props.reqAPI} handleInputEL={() => {}} handleCallback={(e) => { this.setState({pid: e.ID}, this.getOrders) }} />
     </CardFooter>
    </Card>

    <h5 className="text-center">{humanDate}</h5>

    {this.state.orders.length > 0 ?
    this.state.orders.map((order, i) => (
    <Card key={i}>
     <CardHeader>
      <strong>{moment(Date.parse(order.date)).format("H:mm")}</strong>
      <div className="card-actions bg-light">
       <Button disabled><i className={order.payment === '0'?'fa fa-credit-card-alt':'fa fa-money'}></i></Button>
       <Button onClick={() => this.downloadTicket(order.ID)}><i className="fa fa-file-pdf-o"></i></Button>
       <Button><i className="fa fa-close"></i></Button>
      </div>
     </CardHeader>

     <Table className="productList">
      <thead>
       <tr>
        <th className="name">Producto</th>
        <th className="quantity">Cantidad</th>
        <th className="amount">Precio por unidad</th>
        <th className="price">Precio del lote</th>
       </tr>
      </thead>
      <tbody className={order.type === '0'?'text-danger':'text-success'}>
       {order.items.map((item, i) => (
       <tr key={i}>
        <td className="name text-dark">{item.notes ? item.name + ' - '+item.notes : item.name}</td>
        <td className="quantity">{item.quantity}</td>
        <td className="amount">{parseFloat(item.price / item.quantity).toFixed(2)}€</td>
        <td className="price">{parseFloat(item.price).toFixed(2)}€</td>
       </tr>
       ))}
      </tbody>
     </Table>

     <CardFooter>
      <Row>
       <Col md="10">
        <strong>{order.comment !== ''? 'Observaciones':''}</strong><br />
        {order.comment}
       </Col>
       <Col md="2" className="text-right">
        <span style={{fontSize: '150%'}} className={order.type === '0'?'text-danger':'text-success'}>{parseFloat(order.total).toFixed(2)}€</span>
       </Col>
      </Row>
     </CardFooter>
    </Card>
    ))
    :
    <Container>
     <Row className="justify-content-center">
      <Col md="4">
       <div className="clearfix">
        <p className="text-muted text-center">No se ha encontrado ningún ticket para este día.</p>
       </div>
      </Col>
     </Row>
    </Container>
    }
   </section>
  )
 }
}

export default OrderList;



// WEBPACK FOOTER //
// ./src/views/Orders/Ticket.js